import React from "react";
import { Link } from "react-router-dom";
import { PauseCircle, ArrowLeft } from "lucide-react";
import { useRole } from "../lib/role.jsx";

export default function ModulePaused() {
  const { canAccess } = useRole();
  const home = canAccess("/") ? { to: "/", label: "Return to Command Center" }
    : canAccess("/morning-brief") ? { to: "/morning-brief", label: "Open Morning Brief" } : null;
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 animate-fade-in" data-testid="module-paused">
      <div className="w-full max-w-lg text-center">
        <div className="w-14 h-14 rounded-sm bg-info/15 text-info flex items-center justify-center mx-auto">
          <PauseCircle size={26} />
        </div>
        <div className="mt-5 text-[10px] uppercase tracking-[0.22em] text-info font-semibold">Pilot phase</div>
        <h1 data-testid="module-paused-title" className="font-display text-3xl font-semibold tracking-tight mt-2">
          This module is paused for the pilot phase.
        </h1>
        <p className="text-muted text-sm mt-3 leading-relaxed">
          The Control Tower is currently focused on inventory and demand. This area will return when the pilot scope widens.
        </p>
        {home && (
          <Link to={home.to} data-testid="module-paused-home"
                className="mt-7 inline-flex items-center gap-2 h-10 px-4 bg-primary text-primary-fg hover:opacity-90 rounded-sm text-sm font-semibold">
            <ArrowLeft size={14} /> {home.label}
          </Link>
        )}
      </div>
    </div>
  );
}
